module.exports = __webpack_public_path__ + "static/media/certificate.0e83be9a.svg";